var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashBin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 4H2.33325",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5554 5.66663L12.2488 10.266C12.1308 12.036 12.0718 12.9209 11.4952 13.4605C10.9185 14 10.0315 14 8.25768 14H7.7421C5.96824 14 5.0813 14 4.50463 13.4605C3.92796 12.9209 3.86896 12.036 3.75096 10.266L3.44434 5.66663",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33325 4C4.37051 4 4.38913 4 4.40602 3.99957C4.95498 3.98566 5.43927 3.63661 5.62606 3.12021C5.63181 3.10433 5.6377 3.08666 5.64948 3.05132L5.7142 2.85714C5.76946 2.69139 5.79708 2.6085 5.83373 2.53813C5.97993 2.25738 6.25041 2.06242 6.56299 2.01251C6.64134 2 6.7287 2 6.90343 2H9.09641C9.27114 2 9.3585 2 9.43685 2.01251C9.74942 2.06242 10.0199 2.25738 10.1661 2.53813C10.2028 2.6085 10.2304 2.69138 10.2856 2.85714L10.3504 3.05132C10.3621 3.08661 10.368 3.10434 10.3738 3.12021C10.5606 3.63661 11.0449 3.98566 11.5938 3.99957C11.6107 4 11.6293 4 11.6666 4",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBin);
export default __webpack_public_path__ + "static/media/trashBin.53f776cecd8797114cab5ae96fbb430d.svg";
export { ForwardRef as ReactComponent };